// import {
//     // schedulerIntegrationAutocount,
//     schedulerIntegrationSmwClient
// } from "../../../../template/scheduler"

import { getInjectionDataType } from "../../utils/injectionSelection"

export const schedulerServer = {
    // url: "http://scheduler.storemyway.com:1802/"
    url: "https://scheduler.storemyway:1801/"
}

const schedulerIntegrationSdGroup = {
    id: "sdgroup",
    name: "SDGroup",
    dataTypes: [
        getInjectionDataType('container'),
        getInjectionDataType('product'),
        getInjectionDataType('item'),
        // "list2"
    ],
    tasks: [
        {
            id: "sdgroup.inflow.customer",
            name: "Inflow - Customers",
            // description: "SDGroup (Markings) -> SMW (Customers + Branches)"
            description: "SDGroup (Customer) -> SMW (Customers)"
        },
        {
            id: "sdgroup.inflow.agent",
            name: "Inflow - Agents",
            description: "SDGroup (Agents) -> SMW (Customers)"
        },
        {
            id: "sdgroup.inflow.marking",
            name: "Inflow - Markings",
            description: "SDGroup (Markings) -> SMW (Customer Branches)"
        },
        {
            id: "sdgroup.inflow.goods",
            name: "Inflow - Unload Goods",
            description: "SDGroup (Unload Goods) -> SMW (Products & Items)"
        },
        {
            id: "sdgroup.outflow.container",
            name: "Outflow - Containers",
            description: "SMW (Containers) -> SDGroup (Containers)"
        },
        {
            id: "sdgroup.outflow.product",
            name: "Outflow - Products",
            description: "SMW (Products) -> SDGroup (Good)"
        },
        {
            id: "sdgroup.outflow.productItems",
            name: "Outflow - Product Items",
            description: "SMW (Product Items) -> SDGroup (Good Items)"
        },
        // {
        //     id: "sdgroup.branch.customer",
        //     name: "Customer Branches",
        //     description: "SDGroup - Customer Branches"
        // },
        // {
        //     id: "chinlaicrm.customerBranch",
        //     name: "Customer Branch",
        //     description: "CHINLAI CRM - Customer Branch"
        // },
        // {
        //     id: "chinlaicrm.item",
        //     name: "Item",
        //     description: "CHINLAI CRM - Item"
        // },
        // {
        //     id: "chinlaicrm.delivery",
        //     name: "Delivery Orders",
        //     description: "CHINLAI CRM - Delivery Orders"
        // },
        // {
        //     id: "chinlaicrm.cashSales",
        //     name: "Cash Sales",
        //     description: "CHINLAI CRM - Cash Sales"
        // },
    ]
}

export const schedulerIntegrations = [
    // schedulerIntegrationSmwClient,
    // schedulerIntegrationAutocount,
    schedulerIntegrationSdGroup
]